export default {
  hymnals (state) {
    return state.hymnals
  },

  fontSize (state) {
    return state.fontSize
  }
}
